"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ThumbUp = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12.402 3.498A1.7 1.7 0 0011.2 3h-.013a1.7 1.7 0 00-1.558 1.133c-.497 1.407-.972 2.508-1.781 3.312l-.002.001-2.898 2.899A3.2 3.2 0 004 12.598V17.9a3.1 3.1 0 001.67 2.743A3.2 3.2 0 007.094 21H17.1a2 2 0 001.642-3.142 2 2 0 00.58-3.358c.416-.367.678-.903.678-1.5s-.262-1.133-.677-1.5A2 2 0 0018 8h-2.5c-.034 0-.067 0-.1.002V8h-3.201a8.2 8.2 0 00.701-3.299V4.7a1.7 1.7 0 00-.498-1.202zM13.768 9H11.4a.5.5 0 01-.447-.724l.199-.398A7.2 7.2 0 0011.9 4.7a.7.7 0 00-.693-.7.7.7 0 00-.636.466c-.497 1.408-1.032 2.707-2.018 3.688l-2.901 2.901A2.2 2.2 0 005 12.602v5.297a2.1 2.1 0 001.13 1.857 2.2 2.2 0 00.974.244h6.664a1.995 1.995 0 01.41-2.5A1.995 1.995 0 0113.5 16c0-.597.262-1.133.677-1.5A1.995 1.995 0 0113.5 13c0-.597.262-1.133.677-1.5a1.995 1.995 0 01-.41-2.5zM15.5 20h1.6a1 1 0 100-2h-1.6a1 1 0 100 2zm0-11a1 1 0 100 2H18a1 1 0 100-2h-2.5zm-1 4a1 1 0 011-1H18a1 1 0 110 2h-2.5a1 1 0 01-1-1zm1 2a1 1 0 100 2H18a1 1 0 100-2h-2.5z", fillRule: "evenodd" })));
};
ThumbUp.displayName = 'ThumbUp';
exports.default = ThumbUp;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ThumbUp.js.map